import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "color", "fwdRef", "size", "statusMessage", "style"];
import React, { forwardRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { color as colorTokens, size as sizeTokens } from '@op/opds.tokens';
import { gu } from '@op/opds.tokens/lib/web/op/functions';
import { buildVersionedClass, buildVersionedClassNames } from '@op/opds.opux-utilities';
import StatusMessage from '../status-message/status-message';
import messages from './_messages';
import { useLocale } from '../common/locale';
const DEFAULT_SIZE = gu(10);

/**
 * A loading indicator. Additional props (including `ref`) will be forwarded to
 * the wrapping `<span>` element. For accessibility, this component should only be used
 * to indicate loading.
 */
export const Loading = _ref => {
  let {
      className,
      color = colorTokens.indicator.default,
      fwdRef,
      size: propSize = DEFAULT_SIZE,
      statusMessage: propStatusMessage,
      style
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [gradientId] = useState("ds-lgr-" + uuidv4());
  let size = propSize;
  if (propSize === 'small' || propSize === 'default' || propSize === 'large') {
    size = sizeTokens.icon[propSize];
  }
  const dimensions = size !== DEFAULT_SIZE ? {
    height: size,
    width: size
  } : undefined;
  const lc = useLocale();
  let statusMessage = messages.loading[lc];
  if (propStatusMessage) {
    statusMessage = propStatusMessage;
  } else if (propStatusMessage === false || propStatusMessage === null) {
    statusMessage = false;
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    className: buildVersionedClassNames('ds-loading', className),
    ref: fwdRef,
    role: "status",
    style: _extends({}, style, dimensions)
  }, props), /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": "true",
    className: buildVersionedClass('ds-loading__spinner'),
    version: "1.1",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    className: buildVersionedClass('ds-loading__gradient'),
    gradientTransform: "rotate(90)",
    id: gradientId
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: color
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "84%",
    stopColor: color
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 5 50 A 45 45 0 0 1 50 5",
    stroke: "url('#" + gradientId + "')"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50 5 A 45 45 0 0 1 95 50",
    stroke: color
  })), statusMessage && /*#__PURE__*/React.createElement(StatusMessage, {
    hidden: true
  }, statusMessage));
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Loading, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'Loading';
export default Fwd;